// src/constants/data.js

export const TRANSLATIONS = {
  "zh-CN": {
    app_name: "Zeno",
    profile: "个人中心",
    login_title: "欢迎回来",
    login_desc: "登录以同步您的专注数据",
    phone_placeholder: "手机号码",
    code_placeholder: "验证码",
    get_code: "获取",
    login_btn: "登 录",
    skip_login: "暂不登录",
    member_title: "开通会员",
    unlock_title: "解锁完整体验",
    unlock_desc: "投资自己，从每一次专注开始",
    plan_month: "月度会员",
    plan_year: "年度会员",
    plan_lifetime: "终身会员",
    recommend: "推荐",
    save_pct: "立省 30%",
    save_lifetime: "永久拥有",
    lifetime_price: "¥198",
    privilege: "会员权益",
    privileges: [
      { t: "无限神经重放", d: "突破限制，高效记忆强化" },
      { t: "全套高级主题", d: "10+ 精美设计，随心切换" },
      { t: "无损白噪音", d: "8种自然音效，隔绝干扰" },
      { t: "数据云同步", d: "多设备实时备份" },
    ],
    pay_btn: "立即开通",
    pay_agreement: "支付即代表同意《用户协议》与《隐私政策》",
    user_guest: "未登录用户",
    user_login_tip: "点击登录同步数据",
    user_vip: "Zeno Pro",
    user_title: "专注者",
    user_level: "Level 5 Master",
    stats_title: "学习动态",
    stats_duration: "专注时长",
    stats_streak: "连续打卡",
    stats_tasks: "完成任务",
    banner_title: "Zeno Pro",
    banner_desc: "解锁全部高级功能与云同步",
    banner_desc_vip: "尊享所有高级权益",
    banner_active: "已激活",
    sec_personal: "个性化",
    sec_general: "通用",
    theme_title: "界面主题",
    sound_title: "提示音效",
    lang_title: "语言 / Language",
    haptic_title: "触感反馈",
    sync_title: "数据同步",
    settings_neuro: "神经重放设置",
    neuro_switch: "随机提示音",
    neuro_desc: "触发变比率强化，提升专注力",
    neuro_range: "随机间隔范围 (分钟)",
    neuro_tip: "* 提示音响起时，请立即闭眼休息10秒。",
    done_btn: "完成配置",
    close_btn: "关闭",
    start_btn: "开始",
    rest_btn_short: "休息 5 分钟",
    rest_btn_long: "休息 20 分钟",
    continue_btn: "继续",
    congrats_title: "很棒！完成专注",
    week_trend: "本月热力图",
    recent_record: "最近记录",
    today_record: "今日记录",
    day_record: "当日记录",
    total_count: "完成",
    count_unit: "项",
    no_record: "该日暂无专注记录",
    sync_toast: "数据同步成功",
    neuro_toast_title: "闭眼休息 10 秒",
    neuro_toast_desc: "大脑正在重放知识...",
    vip_success_title: "欢迎加入 Zeno Pro",
    vip_success_desc: "您已解锁所有高级权益",
    vip_success_btn: "开始专注之旅",
    sync_last_time: "上次同步",
    sync_cloud_data: "云端数据",
    sync_auto: "自动同步",
    sync_now: "立即同步",
    sync_records: "条记录",
    tags: [
      "专注",
      "休息",
      "深度工作",
      "阅读",
      "写作",
      "学习",
      "会议",
      "运动",
      "小憩",
    ],
  },
  en: {
    app_name: "Zeno",
    profile: "Profile",
    login_title: "Welcome Back",
    login_desc: "Login to sync your focus data",
    phone_placeholder: "Phone Number",
    code_placeholder: "Code",
    get_code: "Get",
    login_btn: "Log In",
    skip_login: "Skip",
    member_title: "Go Pro",
    unlock_title: "Unlock Potential",
    unlock_desc: "Invest in yourself",
    plan_month: "Monthly",
    plan_year: "Yearly",
    plan_lifetime: "Lifetime",
    recommend: "BEST",
    save_pct: "Save 30%",
    save_lifetime: "One-time",
    lifetime_price: "$29.99",
    privilege: "Pro Benefits",
    privileges: [
      { t: "Unlimited Neuro Replay", d: "Break limits, boost memory" },
      { t: "All Premium Themes", d: "10+ designs" },
      { t: "Lossless White Noise", d: "8 nature sounds" },
      { t: "Cloud Sync", d: "Real-time backup" },
    ],
    pay_btn: "Subscribe",
    pay_agreement: "Agree to Terms & Privacy",
    user_guest: "Guest",
    user_login_tip: "Tap to login",
    user_vip: "Zeno Pro",
    user_title: "Focuser",
    user_level: "Level 5 Master",
    stats_title: "Stats",
    stats_duration: "Hours",
    stats_streak: "Streak",
    stats_tasks: "Tasks",
    banner_title: "Zeno Pro",
    banner_desc: "Unlock all features",
    banner_desc_vip: "Premium Active",
    banner_active: "Active",
    sec_personal: "Personalization",
    sec_general: "General",
    theme_title: "Theme",
    sound_title: "Sound",
    lang_title: "Language",
    haptic_title: "Haptics",
    sync_title: "Cloud Sync",
    settings_neuro: "Neuro Replay",
    neuro_switch: "Random Alert",
    neuro_desc: "Variable ratio reinforcement",
    neuro_range: "Interval Range (min)",
    neuro_tip: "* Close eyes for 10s when alert sounds.",
    done_btn: "Done",
    close_btn: "Close",
    start_btn: "Start",
    rest_btn_short: "Rest 5 min",
    rest_btn_long: "Rest 20 min",
    continue_btn: "Continue",
    congrats_title: "Great Job!",
    week_trend: "Monthly Heatmap",
    recent_record: "Recent",
    today_record: "Today",
    day_record: "History",
    total_count: "Done",
    count_unit: "tasks",
    no_record: "No records",
    sync_toast: "Synced successfully",
    neuro_toast_title: "Rest Eyes 10s",
    neuro_toast_desc: "Neuro Replay in progress...",
    vip_success_title: "Welcome to Pro",
    vip_success_desc: "All premium features unlocked",
    vip_success_btn: "Start Focusing",
    sync_last_time: "Last Synced",
    sync_cloud_data: "Cloud Data",
    sync_auto: "Auto Sync",
    sync_now: "Sync Now",
    sync_records: "records",
    tags: [
      "Focus",
      "Break",
      "Deep Work",
      "Reading",
      "Writing",
      "Learning",
      "Meeting",
      "Sport",
      "Nap",
    ],
  },
  "zh-TW": {
    app_name: "Zeno",
    profile: "個人中心",
    login_title: "歡迎回來",
    login_desc: "登入以同步您的專注數據",
    phone_placeholder: "手機號碼",
    code_placeholder: "驗證碼",
    get_code: "獲取",
    login_btn: "登 入",
    skip_login: "暫不登入",
    member_title: "開通會員",
    unlock_title: "解鎖完整體驗",
    unlock_desc: "投資自己，從每一次專注開始",
    plan_month: "月度會員",
    plan_year: "年度會員",
    plan_lifetime: "終身會員",
    recommend: "推薦",
    save_pct: "立省 30%",
    save_lifetime: "一次付費",
    lifetime_price: "NT$890",
    privilege: "會員權益",
    privileges: [
      { t: "無限神經重放", d: "突破限制，高效記憶強化" },
      { t: "全套高級主題", d: "10+ 精美設計，隨心切換" },
      { t: "無損白噪音", d: "8種自然音效，隔絕干擾" },
      { t: "數據雲端同步", d: "多設備即時備份" },
    ],
    pay_btn: "立即開通",
    pay_agreement: "支付即代表同意《用戶協議》與《隱私政策》",
    user_guest: "未登入用戶",
    user_login_tip: "點擊登入同步數據",
    user_vip: "Zeno Pro",
    user_title: "專注者",
    user_level: "Level 5 Master",
    stats_title: "學習動態",
    stats_duration: "專注時長",
    stats_streak: "連續打卡",
    stats_tasks: "完成任務",
    banner_title: "Zeno Pro",
    banner_desc: "解鎖全部高級功能與雲端同步",
    banner_desc_vip: "尊享所有高級權益",
    banner_active: "已激活",
    sec_personal: "個性化",
    sec_general: "通用",
    theme_title: "介面主題",
    sound_title: "提示音效",
    lang_title: "語言 / Language",
    haptic_title: "觸感反饋",
    sync_title: "數據同步",
    settings_neuro: "神經重放設置",
    neuro_switch: "隨機提示音",
    neuro_desc: "觸發變比率強化，提升專注力",
    neuro_range: "隨機間隔範圍 (分鐘)",
    neuro_tip: "* 提示音響起時，請立即閉眼休息10秒。",
    done_btn: "完成配置",
    close_btn: "關閉",
    start_btn: "開始",
    rest_btn: "休息",
    continue_btn: "繼續",
    congrats_title: "很棒！完成專注",
    week_trend: "本月熱力圖",
    recent_record: "最近記錄",
    today_record: "今日記錄",
    day_record: "當日記錄",
    total_count: "完成",
    count_unit: "項",
    no_record: "該日暫無專注記錄",
    sync_toast: "數據同步成功",
    neuro_toast_title: "閉眼休息 10 秒",
    neuro_toast_desc: "大腦正在重放知識...",
    vip_success_title: "歡迎加入 Zeno Pro",
    vip_success_desc: "您已解鎖所有高級權益",
    vip_success_btn: "開始專注之旅",
    sync_last_time: "上次同步",
    sync_cloud_data: "雲端數據",
    sync_auto: "自動同步",
    sync_now: "立即同步",
    sync_records: "條記錄",
    tags: [
      "專注",
      "休息",
      "深度工作",
      "閱讀",
      "寫作",
      "學習",
      "會議",
      "運動",
      "小憩",
    ],
  },
};

export const PRESETS = {
  IPHONE: { ar: "390/844", maxW: 390, radius: 48, label: "iPhone" },
  IPAD: { ar: "3/4", maxW: 768, radius: 32, label: "iPad" },
  WATCH: { ar: "4/5", maxW: 320, radius: 56, label: "Watch" },
  WEB: { ar: "16/10", maxW: 1000, radius: 24, label: "Web" },
};

export const SOUNDS = {
  bell: {
    name: { "zh-CN": "风铃", en: "Bell", "zh-TW": "風鈴" },
    isPro: false,
    url: "https://assets.mixkit.co/active_storage/sfx/2869/2869-preview.mp3",
  },
  nature: {
    name: { "zh-CN": "森林", en: "Forest", "zh-TW": "森林" },
    isPro: true,
    url: "https://assets.mixkit.co/active_storage/sfx/2434/2434-preview.mp3",
  },
  flow: {
    name: { "zh-CN": "流水", en: "Stream", "zh-TW": "流水" },
    isPro: true,
    url: "https://assets.mixkit.co/active_storage/sfx/2418/2418-preview.mp3",
  },
  rain: {
    name: { "zh-CN": "雨声", en: "Rain", "zh-TW": "雨聲" },
    isPro: true,
    url: "https://assets.mixkit.co/active_storage/sfx/2515/2515-preview.mp3",
  },
  fire: {
    name: { "zh-CN": "篝火", en: "Bonfire", "zh-TW": "篝火" },
    isPro: true,
    url: "https://assets.mixkit.co/active_storage/sfx/2402/2402-preview.mp3",
  },
  night: {
    name: { "zh-CN": "静夜", en: "Night", "zh-TW": "靜夜" },
    isPro: true,
    url: "https://assets.mixkit.co/active_storage/sfx/2063/2063-preview.mp3",
  },
  waves: {
    name: { "zh-CN": "海浪", en: "Ocean", "zh-TW": "海浪" },
    isPro: true,
    url: "https://assets.mixkit.co/active_storage/sfx/2048/2048-preview.mp3",
  },
  wind: {
    name: { "zh-CN": "风声", en: "Wind", "zh-TW": "風聲" },
    isPro: true,
    url: "https://assets.mixkit.co/active_storage/sfx/1395/1395-preview.mp3",
  },
  ping: {
    name: { "zh-CN": "顿悟", en: "Ping", "zh-TW": "頓悟" },
    isPro: false,
    url: "https://assets.mixkit.co/active_storage/sfx/2578/2578-preview.mp3",
  },
  mute: {
    name: { "zh-CN": "静音", en: "Mute", "zh-TW": "靜音" },
    isPro: false,
    url: null,
  },
};

export const THEMES = [
  {
    id: "metal",
    category: { "zh-CN": "五行", en: "Element", "zh-TW": "五行" },
    name: "金 · 月白",
    meaning: "收敛 / Focus",
    isPro: false,
    isDark: false,
    bg: "#eef2f5",
    cardBg: "linear-gradient(145deg, #ffffff, #dbe4ef)",
    border: "#cbd5e1",
    text: "text-slate-800",
    sub: "text-slate-400",
    toggle: "text-slate-400 hover:text-slate-600 hover:bg-slate-200/50",
    accent:
      "bg-[#64748b] text-white shadow-xl hover:shadow-2xl hover:shadow-slate-500/30",
    tabActive: "bg-[#64748b] text-white",
    particle: ["#94a3b8", "#e2e8f0", "#f1f5f9"],
  },
  {
    id: "wood",
    category: { "zh-CN": "五行", en: "Element", "zh-TW": "五行" },
    name: "木 · 竹青",
    meaning: "生发 / Growth",
    isPro: true,
    isDark: true,
    bg: "#1a2c26",
    cardBg: "linear-gradient(145deg, #2b453e, #14211d)",
    border: "#3a5c52",
    text: "text-[#e0f2f1]",
    sub: "text-[#80cbc4]",
    toggle: "text-[#80cbc4] hover:text-white hover:bg-white/10",
    accent:
      "bg-[#2d6a4f] text-white shadow-xl hover:shadow-2xl hover:shadow-[#2d6a4f]/40 border border-[#40916c]/30",
    tabActive: "bg-[#2d6a4f] text-white",
    particle: ["#52b788", "#b7e4c7", "#2d6a4f"],
  },
  {
    id: "water",
    category: { "zh-CN": "五行", en: "Element", "zh-TW": "五行" },
    name: "水 · 玄冥",
    meaning: "润下 / Wisdom",
    isPro: true,
    isDark: true,
    bg: "#050505",
    cardBg: "linear-gradient(145deg, #171717, #0a0a0a)",
    border: "#262626",
    text: "text-gray-200",
    sub: "text-gray-500",
    toggle: "text-gray-500 hover:text-white hover:bg-white/10",
    accent:
      "bg-[#1e293b] text-white border border-gray-700 shadow-xl hover:shadow-2xl hover:shadow-white/5",
    tabActive: "bg-[#1e293b] text-white border border-gray-700",
    particle: ["#ffffff", "#334155", "#0f172a"],
  },
  {
    id: "fire",
    category: { "zh-CN": "五行", en: "Element", "zh-TW": "五行" },
    name: "火 · 朱砂",
    meaning: "炎上 / Energy",
    isPro: true,
    isDark: true,
    bg: "#2a0a0a",
    cardBg: "linear-gradient(145deg, #601414, #360505)",
    border: "#7f1d1d",
    text: "text-[#ffedd5]",
    sub: "text-[#fca5a5]",
    toggle: "text-[#fca5a5] hover:text-white hover:bg-white/10",
    accent:
      "bg-[#9b2226] text-white shadow-xl hover:shadow-2xl hover:shadow-[#9b2226]/40",
    tabActive: "bg-[#9b2226] text-white",
    particle: ["#e5383b", "#ba181b", "#ffb703"],
  },
  {
    id: "earth",
    category: { "zh-CN": "五行", en: "Element", "zh-TW": "五行" },
    name: "土 · 赭石",
    meaning: "稼穑 / Grounded",
    isPro: true,
    isDark: true,
    bg: "#3f2e27",
    cardBg: "linear-gradient(145deg, #5d4037, #3e2723)",
    border: "#795548",
    text: "text-[#efebe9]",
    sub: "text-[#d7ccc8]",
    toggle: "text-[#d7ccc8] hover:text-white hover:bg-white/10",
    accent:
      "bg-[#8d6e63] text-white shadow-xl hover:shadow-2xl hover:shadow-[#8d6e63]/40 border border-[#a1887f]/30",
    tabActive: "bg-[#8d6e63] text-white",
    particle: ["#d7ccc8", "#a1887f", "#6d4c41"],
  },
  {
    id: "stoic",
    category: { "zh-CN": "西学", en: "West", "zh-TW": "西學" },
    name: "斯多葛",
    meaning: "理性 / Stoic",
    isPro: false,
    isDark: false,
    bg: "#f3f4f6",
    cardBg: "linear-gradient(145deg, #ffffff, #f3f4f6)",
    border: "#d1d5db",
    text: "text-gray-900",
    sub: "text-gray-400",
    toggle: "text-gray-400 hover:text-gray-600 hover:bg-gray-100",
    accent:
      "bg-gray-800 text-white shadow-xl hover:shadow-2xl hover:shadow-gray-800/20",
    tabActive: "bg-gray-800 text-white",
    particle: ["#9ca3af", "#6b7280", "#4b5563"],
  },
  {
    id: "cyber",
    category: { "zh-CN": "西学", en: "West", "zh-TW": "西學" },
    name: "赛博朋克",
    meaning: "霓虹 / Cyber",
    isPro: true,
    isDark: true,
    bg: "#09090b",
    cardBg: "linear-gradient(145deg, #18181b, #09090b)",
    border: "#22c55e",
    text: "text-pink-500",
    sub: "text-green-500/70",
    toggle: "text-zinc-600 hover:text-pink-400 hover:bg-white/5",
    accent:
      "bg-pink-600 text-white shadow-xl hover:shadow-2xl hover:shadow-pink-600/40 border border-green-500/30",
    tabActive: "bg-pink-600 text-white",
    particle: ["#ec4899", "#22c55e", "#a855f7"],
  },
  {
    id: "industrial",
    category: { "zh-CN": "西学", en: "West", "zh-TW": "西學" },
    name: "蒸汽工业",
    meaning: "秩序 / Steam",
    isPro: true,
    isDark: true,
    bg: "#1c1917",
    cardBg: "linear-gradient(145deg, #292524, #1c1917)",
    border: "#d97706",
    text: "text-amber-50",
    sub: "text-amber-500/50",
    toggle: "text-stone-500 hover:text-amber-400 hover:bg-white/5",
    accent:
      "bg-amber-700 text-white shadow-xl hover:shadow-2xl hover:shadow-amber-700/40",
    tabActive: "bg-amber-700 text-white",
    particle: ["#d97706", "#b45309", "#78350f"],
  },
  {
    id: "impression",
    category: { "zh-CN": "西学", en: "West", "zh-TW": "西學" },
    name: "印象派",
    meaning: "光影 / Light",
    isPro: true,
    isDark: false,
    bg: "#fff7ed",
    cardBg: "linear-gradient(145deg, #fff1f2, #fef3c7)",
    border: "#fcd34d",
    text: "text-indigo-900",
    sub: "text-indigo-400",
    toggle: "text-orange-300 hover:text-indigo-500 hover:bg-white/50",
    accent:
      "bg-indigo-400 text-white shadow-xl hover:shadow-2xl hover:shadow-indigo-400/20",
    tabActive: "bg-indigo-400 text-white",
    particle: ["#818cf8", "#fcd34d", "#fca5a5"],
  },
  {
    id: "interstellar",
    category: { "zh-CN": "西学", en: "West", "zh-TW": "西學" },
    name: "深空",
    meaning: "引力 / Interstellar",
    isPro: true,
    isDark: true,
    bg: "#020617",
    cardBg: "linear-gradient(145deg, #172554, #000000)",
    border: "#1e3a8a",
    text: "text-blue-50",
    sub: "text-blue-300/40",
    toggle: "text-blue-800 hover:text-blue-200 hover:bg-white/10",
    accent:
      "bg-blue-700 text-white shadow-xl hover:shadow-2xl hover:shadow-blue-700/40",
    tabActive: "bg-blue-700 text-white",
    particle: ["#3b82f6", "#60a5fa", "#ffffff"],
  },
];

export const TAG_MAP = {
  专注: 25 * 60,
  休息: 10 * 60,
  深度工作: 90 * 60,
  阅读: 30 * 60,
  写作: 30 * 60,
  学习: 45 * 60,
  会议: 30 * 60,
  运动: 30 * 60,
  小憩: 15 * 60,
};
